import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { APP_CONTROLLER_REDUCERS } from "@gcloud-npm/bit.unifiedcomponents.app-controller";
import commonReducer from "./common";
import productReducer from "./product";

const rootReducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    product: productReducer,
    common: commonReducer,
    context: APP_CONTROLLER_REDUCERS.context,
    errorCatcher: APP_CONTROLLER_REDUCERS.errorCatcher,
  });

export default rootReducers;
